import type {AfriexTransactionProcessor} from '@/types';

// Sentinels for the processor dropdown's two non-processor choices. The shared
// Select renders its placeholder as a disabled `value=""` option, so "any"
// cannot be the empty string.
export const ANY_PROCESSOR = '__any__';
export const NOT_MAPPED = '__unmapped__';

export type ProcessorFilterValue =
  AfriexTransactionProcessor | typeof ANY_PROCESSOR | typeof NOT_MAPPED;

export type BankFilterState = {
  countryCodes: string[];
  processorFilter: ProcessorFilterValue;
  search: string;
};

export const PAGE_SIZE = 20;
